@if (configuration != null) {
  <div class="settlement-footer"
    data-cy="settlement-footer">
    <div class="settlement-footer-right-section">
      <button (click)="footerClick($safeNavigationMigration(configuration?.secondaryButton?.action))"
        [disabled]="$safeNavigationMigration(configuration?.secondaryButton?.disable)"
        class="{{configuration?.secondaryButton?.class}}"
        data-cy="settlement-footer-secondary-button"
        type="button">
        <span class="text">{{configuration?.secondaryButton?.label}}</span>
      </button>
      <button (click)="footerClick($safeNavigationMigration(configuration?.primaryButton?.action))"
        [disabled]="$safeNavigationMigration(configuration?.primaryButton?.disable)"
        class="{{configuration?.primaryButton?.class}}"
        data-cy="settlement-footer-primary-button"
      type="button">{{configuration?.primaryButton?.label}}</button>
    </div>
  </div>
}
